<template>
  <v-card class="tw-w-full !tw-p-8 tw-rounded">
    <div v-if="customConfigureLoading" role="status" class="tw-max-w-sm tw-animate-pulse">
      <div class="tw-h-6 tw-bg-gray-200 tw-rounded-lg dark:tw-bg-gray-700 tw-w-48 tw-mb-4"></div>
    </div>
    <p v-else class="tw-font-medium tw-text-sm tw-tracking-widest tw-font-open-sans">
      {{ modelYear }} {{ divisionName }}
    </p>
    <div v-if="customConfigureLoading" role="status" class="tw-animate-pulse">
      <div class="tw-h-10 tw-bg-gray-200 tw-rounded-lg dark:tw-bg-gray-700 tw-w-full tw-mb-4"></div>
    </div>
    <h2 v-else class="tw-text-2xl tw-font-bold tw-font-open-sans">
      {{ carDetails.styleName }}
      {{ modelName }}
    </h2>
    <div
      v-if="customConfigureLoading"
      role="status"
      class="tw-max-w-sm tw-animate-pulse"
    >
      <div class="tw-h-7 tw-bg-gray-200 tw-rounded-lg dark:tw-bg-gray-700 tw-w-56 tw-mb-4"></div>
    </div>
    <p v-else class="tw-font-medium tw-text-sm tw-tracking-widest tw-font-open-sans">
      {{ carDetails.subStyleName }}
    </p>
    <div v-if="customConfigureLoading" role="status" class="tw-animate-pulse">
      <div class="tw-h-60 tw-bg-gray-200 tw-rounded-lg dark:tw-bg-gray-700 tw-w-full tw-mb-4"></div>
    </div>
    <div v-else class="tw-relative tw-w-full">
      <img
        :key="carDetails.imageURL"
        :class="customMsg != '' && tab.name === 'Options' ? 'tw-opacity-35' : 'tw-opacity-100'"
        class="tw-h-full tw-w-full tw-object-cover tw-my-3"
        :src="carDetails.imageURL"
        :alt="carDetails.styleName"
        decoding="async"
        @load="customToggleImgLoading = false"
        @error="customToggleImgLoading = false"
      />
      <div
        v-if="customMsg != '' && tab.name === 'Options'"
        class="tw-absolute tw-bottom-2 tw-right-0 tw-capitalize tw-text-center tw-w-full tw-text-[#EF4444] tw-font-kanit"
      >
        {{ customMsg }}
      </div>
    </div>
    <p class="tw-text-xs tw-font-light tw-font-open-sans" style="font-style: italic">
      ** Image displayed may not be representative of actual trim level and equipment of the
      selected vehicle.
    </p>
    <div class="tw-mt-6 tw-flex tw-flex-col tw-gap-1">
      <div
        class="tw-flex tw-justify-between tw-w-full tw-items-center !tw-font-extralight tw-font-open-sans"
      >
        <p>Base Price</p>
        <div
          v-if="customConfigureLoading"
          role="status"
          class="tw-max-w-sm tw-animate-pulse"
        >
          <div class="tw-h-6 tw-bg-gray-200 tw-rounded-lg dark:tw-bg-gray-700 tw-w-32"></div>
        </div>
        <p v-else>${{ carDetails.baseMSRP.toLocaleString() }}</p>
      </div>
      <div
        class="tw-flex tw-justify-between tw-w-full tw-items-center !tw-font-extralight tw-font-open-sans"
      >
        <p>Options & Accessories</p>
        <div
          v-if="customConfigureLoading"
          role="status"
          class="tw-max-w-sm tw-animate-pulse"
        >
          <div class="tw-h-6 tw-bg-gray-200 tw-rounded-lg dark:tw-bg-gray-700 tw-w-32"></div>
        </div>
        <p v-else>${{ carDetails.optionsMSRP.toLocaleString() }}</p>
      </div>
      <div
        class="tw-flex tw-justify-between tw-w-full tw-items-center !tw-font-extralight tw-font-open-sans"
      >
        <p>Destination Charge</p>
        <div
          v-if="customConfigureLoading"
          role="status"
          class="tw-max-w-sm tw-animate-pulse"
        >
          <div class="tw-h-6 tw-bg-gray-200 tw-rounded-lg dark:tw-bg-gray-700 tw-w-32"></div>
        </div>
        <p v-else>${{ carDetails.destination.toLocaleString() }}</p>
      </div>
    </div>
    <div class="!tw-bg-black tw-mt-1 !tw-h-[1px] tw-rounded"></div>
    <div
      class="tw-flex tw-justify-between tw-w-full tw-items-center !tw-font-bold tw-text-xl tw-font-open-sans"
    >
      <p>Total Price</p>
      <div
        v-if="customConfigureLoading"
        role="status"
        class="tw-max-w-sm tw-animate-pulse"
      >
        <div class="tw-h-6 tw-bg-gray-200 tw-rounded-lg dark:tw-bg-gray-700 tw-w-32"></div>
      </div>
      <p v-else>${{ carDetails.totalMSRP.toLocaleString() }}</p>
    </div>
    <div
      v-if="tab.name == 'Options'"
      @click="onResetOptions"
      class="tw-font-open-sans tw-font-extralight tw-w-full tw-text-right tw-cursor-pointer"
    >
      Reset Options
    </div>
    <div
      class="tw-flex tw-flex-col tw-justify-end tw-items-end tw-w-full mt-4 mb-5 tw-cursor-pointer tw-font-open-sans"
    >
      <div
        @click="toggleEstimateDialog"
        class="tw-text-sm tw-font-medium tw-flex tw-gap-1 tw-items-center tw-capitalize"
      >
        <p
          v-if="
            paymentDetails.totalMonths === 0 ||
            paymentDetails.cashDown === 0 ||
            paymentDetails.monthlyPaymentVal === 0
          "
        >
          Calculate payment
        </p>
        <p
          v-if="
            paymentDetails.totalMonths != 0 ||
            paymentDetails.cashDown != 0 ||
            paymentDetails.monthlyPaymentVal != 0
          "
        >
          ${{ paymentDetails.monthlyPaymentVal }}/MO
        </p>
        <EstimateDialog
          @toggle-dialog="toggleEstimateDialog"
          :carDetails="carDetails"
          v-model="estimateDialog"
        />
        <v-icon size="15px" class="tw-ml-[2px]" icon=" fa fa-calculator"></v-icon>
      </div>
      <p
        v-if="
          paymentDetails.totalMonths != 0 ||
          paymentDetails.cashDown != 0 ||
          paymentDetails.monthlyPaymentVal != 0
        "
        class="!tw-font-extralight tw-font-open-sans"
      >
        ${{ paymentDetails.cashDown }} Cash Down, {{ paymentDetails.totalMonths }} Months
      </p>
    </div>
    <p class="tw-text-xs tw-font-light tw-font-open-sans" style="font-style: italic">
      +Tax, title, license fees, dealer documentation fees, and accessory installation are extra.
    </p>
    <slot />
  </v-card>
</template>

<script setup>
import { computed, ref, watch, onMounted } from 'vue';
import EstimateDialog from '@/components/common/Dialog/EstimateDialog.vue';
import { useCarsStore } from '@/stores/useCarsStore';
import { storeToRefs } from 'pinia';
import { useVariablesStore } from '@/stores/useVariablesStore';

const carStore = useCarsStore();
const variableStore = useVariablesStore();
const { tab } = storeToRefs(variableStore);
const { resetOptions } = carStore;

const onResetOptions = async () => {
  await resetOptions();
};
const {
  modelConfigurationDetails,
  customConfigureLoading,
  paymentDetails,
  carDetails,
  customMsg,
  customToggleImgLoading,
  toggleOptionData,
} = storeToRefs(carStore);

const modelDetails = computed(() => {
  const details = carDetails.value.modelDetails;
  return typeof details === 'object' && details ? details : {};
});
const modelYear = computed(() => modelDetails.value.modelYear ?? '');
const divisionName = computed(() => modelDetails.value.divisionName ?? '');
const modelName = computed(() => modelDetails.value.modelName ?? '');

const estimateDialog = ref(false);
const toggleEstimateDialog = () => {
  estimateDialog.value = !estimateDialog.value;
};

watch(
  () => toggleOptionData,
  (newVal) => {
    if (!newVal.value?.style || newVal.value?.status === 'UserConfirmationNeeded') return;

    let selDescription = newVal.value?.options?.[0]?.options?.[0]?.descriptions?.[0]?.description;
    newVal.value?.options?.[0]?.options?.forEach((option) => {
      if (
        newVal.value.style.configurationState.selectedChromeOptionCodes.includes(
          option.chromeOptionCode,
        )
      ) {
        selDescription = option.descriptions[0].description;
      }
    });

    carStore.$patch({
      carDetails: {
        ...carStore.carDetails,
        baseMSRP: newVal.value.style.baseMsrp,
        optionsMSRP: newVal.value.configuredOptionsMsrp,
        totalMSRP: newVal.value?.configuredTotalMsrp,
        subStyleName: selDescription,
      },
    });
  },
  { deep: true },
);

onMounted(() => {
  if (!modelConfigurationDetails.value) return;
  if (carDetails.value.totalMSRP || carDetails.value.optionsMSRP || carDetails.value.baseMSRP) {
    return;
  }

  carDetails.value.baseMSRP = modelConfigurationDetails.value?.style?.baseMsrp || 0;
  carDetails.value.destination = modelConfigurationDetails.value?.style?.destination || 0;
  carDetails.value.styleName = modelConfigurationDetails.value?.style?.styleName || 'Unknown';
  carDetails.value.modelDetails = modelConfigurationDetails.value?.style?.model || 'Unknown';
  carDetails.value.optionsMSRP = modelConfigurationDetails.value?.configuredOptionsMsrp || 0;
  carDetails.value.totalMSRP = modelConfigurationDetails.value?.configuredTotalMsrp || 0;
  carStore.syncExteriorColorPreview(carStore.selectedColor, { commitSelection: false });
});
</script>

<style scoped></style>
